// extracted by mini-css-extract-plugin
module.exports = {"MapSettings":"MapSettings_MapSettings__cKLaO","ShortInput":"MapSettings_ShortInput__3Anf-"};